const DataPartitionStatisticCountFields = [
    'totalCount',
    'errorsCount',
    'notChangedCount',
    'newCount',
    'updatedCount',
    'deletedCount',
    'mergedCount',
    'skippedCount',
    'skippedByVendorCount',
    'duplicatesCount',
    'ignoredCount',
    'invalidCount'
];

export class DataPartitionStatistic {
    public totalCount = 0;
    public errorsCount = 0;

    public dataType: string;
    // public districtGuid: string;
    // public districtName: string;
    public partitionId: string;
    public partitionTitle: string;
    public direction: DataStatisticDirection;

    public notChangedCount = 0;
    public newCount = 0;
    public updatedCount = 0;
    public deletedCount = 0;
    public mergedCount = 0;
    public skippedCount = 0;
    public skippedByVendorCount = 0;
    public duplicatesCount = 0;
    public ignoredCount = 0;
    public invalidCount = 0;

    public out: DataPartitionStatistic;

    static isEmpty(data: DataPartitionStatistic): boolean {
        return DataPartitionStatisticCountFields.every((attrName: string) =>
            data[attrName] === null
        );
    }

    static sum(data1: DataPartitionStatistic, data2: DataPartitionStatistic): DataPartitionStatistic {
        DataPartitionStatisticCountFields.forEach((attrName: string) =>
            data1[attrName] += data2[attrName]
        );
        return data1;
    }

    static setCounters(data1: DataPartitionStatistic, data2: DataPartitionStatistic): DataPartitionStatistic {
        DataPartitionStatisticCountFields.forEach((attrName: string) =>
            data1[attrName] = data2[attrName]
        );
        return data1;
    }

    constructor(dataType: string = '') {
        this.dataType = dataType;
    }
}

export const ERRORS_PARTITION_ID = 'ERRORS';

export enum DataStatisticDirection {
    IN = 'IN',
    OUT = 'OUT'
}
